export function scrollToTop({ behavior = 'smooth' } = {}) {
  window.scrollTo({ top: 0, left: 0, behavior });
}

export function scrollToSection(id, { behavior = 'smooth', maxAttempts = 30, interval = 100 } = {}) {
  const sectionId = id.replace(/^#/, '');
  if (!sectionId) {
    return;
  }

  let attempts = 0;

  const tryScroll = () => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior, block: 'start' });
      return;
    }

    attempts += 1;
    if (attempts < maxAttempts) {
      window.setTimeout(tryScroll, interval);
    }
  };

  tryScroll();
}
